/**
 * cloudWatch模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const cloudWatch = {
  //查询当前模块下所有cloudWatch指标
  checkMonitorModuleIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkMonitorModuleIndex`,params);
  },
  //slb折线图
  checkAliCloudSLBStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAliCloudSLBStatistics`,params);
  },
  //GCP折线图
  checkGcpLoadbalanceIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpLoadbalanceIndex`,params);
  },
  //ECS折线图
  checkALIECSIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALIECSIndex`,params);
  },
  //Azure折线图
  checkAzureVmIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureVmIndex`,params);
  },
  //GCP折线图
  checkGcpVmIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpVmIndex`,params);
  },
  //Azure MySQL折线图
  checkAzureCloudDBforMySQLStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureCloudDBforMySQLStatistics`,params);
  },
  //Azure SQLserver折线图
  checkAzureCloudSQLServerStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureCloudSQLServerStatistics`,params);
  },
  //Azure 磁盘折线图
  checkAzureCloudVMDiskStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureCloudVMDiskStatistics`,params);
  },
  //Aliyun 磁盘折线图
  checkAliyunDiskStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAliyunDiskStatistics`,params);
  },

  //GCP 磁盘折线图
  checkGCPDiskStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpDiskIndex`,params);
  },

  //Azure agw折线图
  checkAzureApplicationGatewayStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureApplicationGatewayStatistics`,params);
  },
  //Azure web折线图
  checkAzureAppService(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAzureAppService`,params);
  },
  //查询时间范围
  queryTimeHorizon(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/cloudWatch/queryTimeHorizon`,param);
  },
  //Aws redshift折线图
  checkAWSRedshiftStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAWSRedshiftStatistics`,params);
  },
  //elasticsearch折线图
  checkAWSEsStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAWSEsStatistics`,params);
  },
  //ELB折线图
  checkALBAndNlbStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALBAndNlbStatistics`,params);
  },
  //ELK折线图
  checkVmwareMonitorModuleIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkVmwareMonitorModuleIndex`,params);
  },
  //StorageGateway折线图
  checkAWSStorageGatewayStatistics(params){
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAWSStorageGatewayStatistics`,params);
  },
  //redis折线图
  checkAWSElastiCacheStatistics(params){
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAWSElastiCacheStatistics`,params);
  },
  //弹性IP AWS折线图
  checkALIEIPIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALIEIPIndex`,params);
  },
  //查询当前模块下Ali Redis cloudWatch指标监控折线图
  checkAliRedisStatistics(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAliRedisStatistics`,params);
  },
  //查询当前模块下GCP Redis cloudWatch指标监控折线图
  checkGcpRedisIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpRedisIndex`,params);
  },
  //查询当前模块下弹性伸缩指标监控折线图
  checkALIESSIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALIESSIndex`,params);
  },

  //查询当前模块下Waf指标监控折线图
  checkALIWafIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALIWafIndex`,params);
  },
  //查询当前模块下对象存储指标监控折线图
  checkALIOssIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkALIOssIndex`,params);
  },
  //查询当前模块下cloudSql指标监控折线图
  checkGcpCloudSQLIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpCloudSQLIndex`,params);
  },

  //查询分组依据下拉框
  redisGroupByBox(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/gcpRedis/redisGroupByBox`,param);
  },

  // -----------------------------------------------------------------
  // 2022.7.7 tiya 新增
  //GCP 根据时间范围查询图表数据
  queryCheckGcpCloudStorageIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkGcpCloudStorageIndex`,params);
  },
  //  监控告警管理 下查询实例 磁盘 数据库 预测指标
  queryCheckAiIndex(params) {
    return $http.post(`${global.API_URL}/sme/cloudWatch/checkAiIndex`,params);
  },
}

export default cloudWatch;



// WEBPACK FOOTER //
// ./src/api/cloudWatch.js